import { useQuery } from '@tanstack/vue-query'
import { unref, type MaybeRef } from 'vue'
import { getWalletStatus } from '../api/walletEndpoints'
import { walletKeys } from '../api/walletQueryKeys'

export function useWalletStatusQuery(offeringId: MaybeRef<string>) {
  return useQuery({
    queryKey: walletKeys.status(unref(offeringId)),
    queryFn: () => getWalletStatus(unref(offeringId)),
    enabled: () => Boolean(unref(offeringId)),
  })
}
